/**
 * 密码相关配置
 */

// 弱密码列表，登录时不允许设置这些密码
export const weakPasswordList = [
  "123456",
  "password",
  "111111",
  "12345678",
  "123123",
  "000000",
  "1234567",
  "12345",
  "1234567890",
  "88888888",
  "666666",
  "123456789",
  "abcd1234",
  "qwerty",
  "abc123",
  "admin123",
  "admin888",
  "administrator"
];

// 密码强度检验
export const passwordStrength = {
  weak: /^[0-9]{6,}$/,  // 纯数字（仅将纯数字视为弱密码）
  medium: /^(?=.*[0-9])(?=.*[a-zA-Z])[0-9a-zA-Z]{6,}$/,  // 数字和字母的组合
  strong: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*(),.?":{}|<>])[0-9a-zA-Z!@#$%^&*(),.?":{}|<>]{8,}$/  // 包含数字、大小写字母和特殊字符
}; 